import React from 'react';
import {paths} from '../../common/dictionaries/urls';
import SpecialParts from './list';
import SpecialPartsAdd from './add';
import SpecialPartsEdit from './edit';

export const specialPartsRoutes = [
  {
    'component': <SpecialParts />,
    'path': paths.SpecialParts,
  },
  {
    'component': <SpecialPartsAdd />,
    'path': paths.SpecialPartsAdd,
  },
  {
    'component': <SpecialPartsEdit />,
    'path': paths.SpecialPartsEdit,
  },
];
